import { useCallback } from "react";
import { useForm } from "react-hook-form";
import { InputFormField } from "../../../formfields/InputFormField";
import { QuickAddChildrenProps } from "../common/QuickAddWrapper";
import { FormButtons } from "../../FormButtons";
import { FormHeader } from "../../FormHeader";
import { Sample, samplesConstants } from "../../../../api/Samples";
import { useQuickAddSubmit } from "../common/useQuickAddHooks";
import { ProjectsVirtualizedSelectForm } from "../../EntityForms/formsVirtualized/ProjectsVirtualizedSelectForm";
import {
  EntityCustomTypeForm,
  useCustomTypeForm,
  useCustomTypeResolver,
} from "../../../../Customization/CustomTypes/generics/useCustomTypeForm";
import { sampleFormBaseSchema } from "../../../../samples/SampleForm";

export const QuickAddSampleForm = ({ onCreate, onCancel, initialValues }: QuickAddChildrenProps<Sample>) => {
  const { onSubmit, loading } = useQuickAddSubmit<Sample>({
    resource: samplesConstants.resource,
    onCreate: onCreate,
    onCancel: onCancel,
  });
  const { typedResolver } = useCustomTypeResolver<Partial<Sample>>(sampleFormBaseSchema);

  // const { defaultValues, typedFormSchema, processCustomFields, type, setType, types } = useCustomTypeForm({
  //   initialValues: initialValues,
  //   formSchema: sampleFormBaseSchema,
  //   typeId: initialValues?.customType?.id,
  //   entityType: "Sample",
  // });

  const processEntity = useCallback((entity: Partial<Sample>) => {
    return {
      ...entity,
      customType: entity.customType ?? null,
      ...(!entity.customType && { customFields: {} }),
    } as Partial<Sample>;
  }, []);

  const {
    reset,
    getValues,
    control,
    register,
    handleSubmit,
    setValue,
    formState: { errors, isSubmitting },
  } = useForm<Partial<Sample>>({
    defaultValues: initialValues,
    resolver: typedResolver,
  });
  const { processCustomFields, types } = useCustomTypeForm({
    control,
    reset,
    getValues,
    entityType: "Sample",
  });

  return (
    <>
      <FormHeader title={"Add Sample"} />

      <fieldset>
        <legend className="col-md-offset-2 col-md-10">Details</legend>
      </fieldset>
      <InputFormField id={"name"} label={"Name"} errors={errors} register={register} autoFocus={true} required={true} />

      <ProjectsVirtualizedSelectForm
        id={"projects"}
        control={control}
        required
        isMulti
        allowCreateEntity
        horizontal
        filters={{ currentUserHasAddPermission: true }}
      />

      <EntityCustomTypeForm
        entityType="Sample"
        types={types}
        control={control}
        setValue={setValue}
        initialValues={initialValues}
        errors={errors}
        entityConstants={samplesConstants}
      />

      <FormButtons
        onClose={onCancel}
        onSubmit={handleSubmit(async (entity) => await onSubmit(processCustomFields(processEntity(entity))))}
        disabled={isSubmitting}
        errors={errors}
        submitButtonLabel="Create"
        loading={loading}
      />
    </>
  );
};
